import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=309b594e&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"
import style0 from "./Radio.vue?vue&type=style&index=0&id=309b594e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309b594e",
  null
  
)

export default component.exports